export default __webpack_public_path__ + "static/media/5.69b22f35.png";